import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import LayoutContext from '../../../store/Layout/contexts';
import AppContext from '../../../store/App/contexts';
import { GET, newFetch } from '../../../helpers/fetch';
import { orderBy } from 'natural-orderby';
import TitleFilterNav from '../../../components/SmartScheduler/TitleFilterNav';
import placeholderImage from '../../../assets/images/placeholder.jpg';

const Navbar = ({ img, name }) => {
  const {
    selectedClientID,
    selectedSiteID,
    clientFilterHandler,
    siteFilterHandler,
  } = React.useContext(AppContext);
  const type = localStorage.getItem('type');
  const [activeClient, SetActiveClient] = useState(null);
  const [activeSite, setActiveSite] = useState(null);
  const [clients, setClients] = useState([]);
  const [sites, setSites] = useState([]);

  const fetchClients = async () => {
    let api_path = `/client/options`;
    let response = await newFetch(GET, api_path);

    if (response?.success) {
      const clientsData = orderBy(
        response.data.filter((client) => client.active === true),
        [(client) => client.name]
      ).map((client) => ({
        ...client,
        sites: orderBy(
          (client.sites || []).filter((site) => site.active === true),
          [(site) => site.name]
        ),
      }));
      localStorage.setItem('clientSiteOptions', JSON.stringify(clientsData));
      setClients(clientsData);

      if (clientsData.length === 0) {
        localStorage.setItem('client', 0);
        localStorage.setItem('site', 0);
        SetActiveClient(0);
        setActiveSite(0);
        setSites([]);
        selectedClientID != 0 && clientFilterHandler(0);
        selectedSiteID != 0 && siteFilterHandler(0);
        return;
      }

      const selectedClient =
        clientsData.find((client) => client.id == selectedClientID) ||
        clientsData[0];
      const validClientID = selectedClient.id;
      const sitesData = orderBy(
        (selectedClient.sites || []).filter((site) => site.active === true),
        [(site) => site.name]
      );
      const allSitesSelected =
        sitesData.length > 1 && Number(selectedSiteID) === 0;
      const selectedSite =
        sitesData.find((site) => site.id == selectedSiteID) || sitesData[0];
      const validSiteID = allSitesSelected
        ? 0
        : selectedSite
          ? selectedSite.id
          : 0;

      localStorage.setItem('client', validClientID);
      localStorage.setItem('site', validSiteID);
      SetActiveClient(validClientID);
      setActiveSite(validSiteID);
      setSites(sitesData);
      selectedClientID != validClientID &&
        clientFilterHandler(validClientID);
      selectedSiteID != validSiteID && siteFilterHandler(validSiteID);
    }
  };

  const changeSiteHandler = (e) => {
    const siteID = e.target.value;
    setActiveSite(siteID);
    localStorage.setItem('site', siteID);
  };

  useEffect(() => {
    localStorage.getItem('access') && fetchClients();
  }, []);

  useEffect(() => {
    if (selectedSiteID !== null && selectedSiteID !== undefined) {
      setActiveSite(selectedSiteID);
    }
  }, [selectedSiteID]);

  return (
    <LayoutContext.Consumer>
      {({ sidebarToggleHandler }) => (
        <nav
          className="navbar bg-white border-left-0 justify-content-start shadow-bottom"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between', // Ensure items are spaced correctly
            paddingLeft: '2rem',
            paddingRight: '2rem',
          }}
        >
          {/* Sidebar toggle icon */}
          <i
            className="fas fa-bars pe-4"
            onClick={sidebarToggleHandler}
            style={{ cursor: 'pointer' }}
          ></i>

          {/* Centered TitleFilterNav */}
          <div
            style={{
              flex: 1,
            }}
          >
            <TitleFilterNav
              options={clients}
              activeClient={activeClient}
              changeSite={changeSiteHandler}
              sites={sites}
              activeSite={activeSite}
              setSites={setSites}
              setActiveSite={setActiveSite}
            />
          </div>

          {/* Right-side items */}
          <span className="navbar-text d-flex align-items-center">
            {type !== 'client' && (
              <Link to="/notifications">
                <i
                  className="fa fa-bell-o"
                  style={{ color: '#5156be', fontSize: '1.2rem' }}
                ></i>
              </Link>
            )}
            <div className="dropdown ps-2" id="dropdownMenuButton">
              <button
                className="btn dropdown-toggle adjust-fs"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img
                  src={img}
                  alt="default"
                  className="rounded-circle border"
                  style={{
                    height: '30px',
                    width: '30px',
                    backgroundColor: '#74788d',
                    padding: '1px',
                  }}
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = placeholderImage;
                  }}
                />

                <span
                  className="px-2 fw-semibold"
                  style={{
                    color: 'inherit',
                    fontSize: '0.8rem',
                    textDecoration: 'none',
                  }}
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Hello! {name}
                </span>
              </button>
              <div
                className="dropdown-menu dropdown-menu-right mt-2 ms-2 rounded-1 p-1"
                style={{ width: '150px' }}
                aria-labelledby="dropdownMenuButton"
              >
                <Link to="/logout" className="dropdown-item adjust-fs">
                  <i className={`fa fa-sign-out me-2 text-muted`}></i>{' '}
                  <span className="text-muted">Logout</span>
                </Link>
              </div>
            </div>
          </span>
        </nav>
      )}
    </LayoutContext.Consumer>
  );
};

export default Navbar;
